import { render, staticRenderFns } from "./grid-col-offset-editor.vue?vue&type=template&id=00657fbe&scoped=true&"
import script from "./grid-col-offset-editor.vue?vue&type=script&lang=js&"
export * from "./grid-col-offset-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00657fbe",
  null
  
)

export default component.exports